
export const GatorProtectActionTypes = {
  GATOR_PROTECT_LOADING: 'GATOR_PROTECT_LOADING',
  GATOR_PROTECT_LIST_PLANS_REQUEST: 'GATOR_PROTECT_LIST_PLANS_REQUEST',
  GATOR_PROTECT_LIST_PLANS_SUCCESS: 'GATOR_PROTECT_LIST_PLANS_SUCCESS',
  GATOR_PROTECT_LIST_PLANS_FAILURE: 'GATOR_PROTECT_LIST_PLANS_FAILURE',
  GATOR_PROTECT_LIST_PLANS_SET: 'GATOR_PROTECT_LIST_PLANS_SET',
  GATOR_PROTECT_GET_PLAN_DETAILS_REQUEST: 'GATOR_PROTECT_GET_PLAN_DETAILS_REQUEST',
  GATOR_PROTECT_GET_PLAN_DETAILS_SUCCESS: 'GATOR_PROTECT_GET_PLAN_DETAILS_SUCCESS',
  GATOR_PROTECT_GET_PLAN_DETAILS_FAILURE: 'GATOR_PROTECT_GET_PLAN_DETAILS_FAILURE',
  GATOR_PROTECT_GET_PLAN_DETAILS_SET: 'GATOR_PROTECT_GET_PLAN_DETAILS_SET',
  GATOR_PROTECT_SET_AUTO_PROTECT: 'GATOR_PROTECT_SET_AUTO_PROTECT',
  GATOR_PROTECT_UPDATE_AUTO_PROTECT_REQUEST: 'GATOR_PROTECT_UPDATE_AUTO_PROTECT_REQUEST',
  GATOR_PROTECT_SET_PLAN_DETAILS_LOADED: 'GATOR_PROTECT_SET_PLAN_DETAILS_LOADED',
  GATOR_PROTECT_PURCHASE_FAST_CHECKOUT_REQUEST: 'GATOR_PROTECT_PURCHASE_FAST_CHECKOUT_REQUEST',
  GATOR_PROTECT_PURCHASE_UPGRADE_ORDER_REQUEST: 'GATOR_PROTECT_PURCHASE_UPGRADE_ORDER_REQUEST',
  GATOR_PROTECT_ACCEPT_TERMS_REQUEST: 'GATOR_PROTECT_ACCEPT_TERMS_REQUEST',
  GATOR_PROTECT_ACCEPT_TERMS_SUCCESS: 'GATOR_PROTECT_ACCEPT_TERMS_SUCCESS',
  GATOR_PROTECT_ACCEPT_TERMS_FAILURE: 'GATOR_PROTECT_ACCEPT_TERMS_FAILURE',
  GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_REQUEST: 'GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_REQUEST',
  GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_SUCCESS: 'GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_SUCCESS',
  GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_FAILURE: 'GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_FAILURE',
  GATOR_PROTECT_PLAN_THREATS_REQUEST: 'GATOR_PROTECT_PLAN_THREATS_REQUEST',
  GATOR_PROTECT_PLAN_THREATS_SET: 'GATOR_PROTECT_PLAN_THREATS_SET',
  GATOR_PROTECT_PLAN_THREATS_SUCCESS: 'GATOR_PROTECT_PLAN_THREATS_SUCCESS',
  GATOR_PROTECT_PLAN_THREATS_FAILURE: 'GATOR_PROTECT_PLAN_THREATS_FAILURE',
  GATOR_PROTECT_PLAN_THREATS_LOADING: 'GATOR_PROTECT_PLAN_THREATS_LOADING',
};
